import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { TranslationProvider } from 'i18nano'
import { Suspense } from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { queryClient } from 'shared/api/core/tanstack-query-config'
import {
	DEFAULT_LANGUAGE,
	FALLBACK_LANGUAGE,
	translations,
} from 'shared/lib/i18n'
import { getStorage } from 'shared/lib/storage'
import { Toaster } from 'sonner'

export function Providers({ children }: { children: React.ReactNode }) {
	return (
		<Suspense>
			<ErrorBoundary fallback={'Oops, an error occurred!'}>
				<QueryClientProvider client={queryClient}>
					<TranslationProvider
						translations={translations.common}
						fallback={FALLBACK_LANGUAGE}
						language={
							getStorage('user-preferences')?.language || DEFAULT_LANGUAGE
						}
						transition={true}
					>
						{children}

						<Toaster position='top-right' richColors />
					</TranslationProvider>

					<ReactQueryDevtools initialIsOpen={false} />
				</QueryClientProvider>
			</ErrorBoundary>
		</Suspense>
	)
}
